/* istanbul ignore file */
// TODO: Create test file

import {
  SET_CTA_JUMP_CLICK,
  SET_OUTFIT_AVAILIBILITY,
} from '../../types/setters';

export const state = () => ({
  ctaJumpclick: false,
  outfitsAvailability: false,
});

export const mutations = {
  [SET_CTA_JUMP_CLICK](_state, payload) {
    _state.ctaJumpclick = payload;
  },
  [SET_OUTFIT_AVAILIBILITY](_state, payload) {
    _state.outfitsAvailability = payload;
  },
};

export const actions = {};
